import { Camera } from '@react-three/fiber';
import { selectors } from '@sloyd/store-base';
import TWEEN, { Group } from '@tweenjs/tween.js'; // Ensure TWEEN is properly imported
import BezierEasing from 'bezier-easing';
import { select } from 'saga-ts';
import { invokeEvent } from 'shared-base';
import { sphericalToCartesian } from '../../components/Three/Three.utils';

let camera: Camera;

export const group = new Group();
const runningTweens: any = {};

export function* playKeyframeCamera(keyframe: IKeyframe) {
  try {
    if (!keyframe) {
      throw new Error('No keyframe');
    }

    const { valuesKeyframe: values } = keyframe;
    const { bezier } = values;

    const allFrames: IKeyframe[] = yield* select(selectors.base.$cameraKeyframes);
    const index = allFrames.findIndex((f) => f.id === keyframe.id);

    const keyframeNext = allFrames[index + 1];
    if (!keyframeNext || !bezier || !camera) {
      throw new Error('No next keyframe or bezier or camera');
    }

    const easing = BezierEasing(...bezier);

    const delta = keyframeNext.ts - keyframe.ts;

    if (runningTweens[keyframe.id]) {
      console.log('tween already running', keyframe.id);
      return;
    }

    const { x, y, z } = sphericalToCartesian(values.radius, values.alpha, values.beta);

    if (!camera) {
      throw new Error('No camera');
    }

    const tween = new TWEEN.Tween(camera.position)
      .to(
        {
          x,
          y,
          z,
        },
        Math.round(delta * 1000)
      )
      .easing((t) => easing(t))
      .start()
      .onComplete(() => {
        console.log('Tween completed', keyframe.id);
        delete runningTweens[keyframe.id]; // Correct the typo
        group.remove(tween);
      });

    runningTweens[keyframe.id] = tween;
    group.add(tween);
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export const setCamera = (value: Camera) => {
  camera = value;
};

export function stopAll() {
  console.log('Stopping all tweens:', runningTweens);
  for (const key in runningTweens) {
    const tween = runningTweens[key];
    if (tween) {
      console.log(`Stopping tween for key: ${key}`);
      group.remove(tween);
      runningTweens[key].stop();
      delete runningTweens[key];
    }
  }
}
